import { parseIfValid } from './json';

/**
 * Info POS del comercio logueado, persistida en localStorage al iniciar sesión.
 * Estructura: { id, name, pos, is_root, parent_id, parent_pos }
 *
 * @returns {object|null}
 */
export function getPosInfo() {
  return parseIfValid(localStorage.getItem('pos_info'), false) || null;
}

/**
 * Id del comercio dueño del catálogo de productos:
 *  - propio si el comercio tiene pos (properties.pos = true)
 *  - si no, el ancestro que sí tiene pos: `parent_pos` trae ESE id
 *    (p.ej. { pos: false, parent_id: 1767, parent_pos: 1767 } -> 1767)
 *  - null si ni él ni sus padres tienen pos configurado
 *
 * @returns {number|null}
 */
export function getCatalogCommerceId() {
  const info = getPosInfo();

  if (!info) {
    return null;
  }

  if (info.pos === true) {
    return info.id ?? null;
  }

  // parent_pos = id del ancestro con pos (o null si ninguno).
  // Por robustez, si llegara como booleano true se usa parent_id.
  if (info.parent_pos) {
    return info.parent_pos === true
      ? (info.parent_id ?? null)
      : info.parent_pos;
  }

  return null;
}

/**
 * El comercio actual administra su propio catálogo (puede crear/editar productos).
 *
 * @returns {boolean}
 */
export function isCatalogOwner() {
  return getPosInfo()?.pos === true;
}

/**
 * Puede usar el catálogo (propio o el del padre) para asignar productos.
 *
 * @returns {boolean}
 */
export function canUseCatalog() {
  return getCatalogCommerceId() != null;
}
